import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var ASSIGNMENT_CONFIGURATION_CACHED = 'ASSIGNMENT_CONFIGURATION_CACHED';
export var AssignmentConfigurationCached = /*#__PURE__*/function () {
  function AssignmentConfigurationCached() {
    _classCallCheck(this, AssignmentConfigurationCached);
  }

  _createClass(AssignmentConfigurationCached, [{
    key: "setAssignmentConfigurationCached",
    value: function setAssignmentConfigurationCached(assignmentConfiguration, locale) {
      var cachedData = this.getAssignmentConfigurationCached(locale);

      if (!cachedData) {
        localStorage.setItem(locale ? "".concat(ASSIGNMENT_CONFIGURATION_CACHED, "_").concat(locale) : "".concat(ASSIGNMENT_CONFIGURATION_CACHED), JSON.stringify(assignmentConfiguration));
      }
    }
  }, {
    key: "getAssignmentConfigurationCached",
    value: function getAssignmentConfigurationCached(locale) {
      var result = null;
      var cachedData = JSON.parse(localStorage.getItem(locale ? "".concat(ASSIGNMENT_CONFIGURATION_CACHED, "_").concat(locale) : "".concat(ASSIGNMENT_CONFIGURATION_CACHED)));

      if (cachedData) {
        result = cachedData;
      }

      return result;
    }
  }]);

  return AssignmentConfigurationCached;
}();